<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    id="page-login"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <form class="p-8 login-tabs-container" @submit.prevent="login">
                <img
                  src="@/assets/images/logo/logo-full.png"
                  alt="login"
                  class="mb-10 self-center ml-auto mr-auto"
                  style="max-width:15rem;"
                />
                <div class="vx-card__title">
                  <h4 class="p3-4">
                    Login
                  </h4>
                </div>

                <div>
                  <div v-if="loginErrors.length" class="mb-3">
                    <vs-alert color="danger">
                      <div v-for="(error, key) in loginErrors" :key="key">
                        {{ $t(error) }}
                      </div>
                    </vs-alert>
                  </div>

                  <vs-input
                    v-model="email"
                    name="email"
                    icon-no-border
                    icon="fa fa-user"
                    icon-pack="feather"
                    label-placeholder="E-Mail"
                    class="w-full"
                  />

                  <vs-input
                    v-model="password"
                    type="password"
                    name="password"
                    icon-no-border
                    icon="fa fa-lock"
                    icon-pack="feather"
                    label-placeholder="Passwort"
                    class="w-full mt-6"
                  />

                  <div class="flex flex-wrap justify-between my-5">
                    <!--
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Eingeloggt bleiben</vs-checkbox>
                      -->
                    <router-link :to="{ name: 'forgot-password' }">
                      Passwort vergessen?
                    </router-link>
                  </div>
                  <button class="d-none"></button>
                  <vs-button :disabled="loading" @click="login"
                    >Einloggen</vs-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { onLogin } from "@/vue-apollo";
import gql from "graphql-tag";

export default {
  data() {
    return {
      loading: false,
      email: "",
      password: "",
      checkbox_remember_me: false,
      loginErrors: []
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($email: String!, $password: String!) {
              login(input: { email: $email, password: $password })
            }
          `,
          variables: {
            email: this.email,
            password: this.password
          }
        })
        .then(async ({ data }) => {
          try {
            await onLogin(this.$apollo, data.login);
            await this.$store.dispatch("user/fetchUser", this.$apollo);
            this.$router.push("/");
          } catch (e) {
            this.loading = false;
          }
        })
        .catch(error => {
          this.loginErrors = error.graphQLErrors.map(m => m.message);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
